import { createSlice  } from '@reduxjs/toolkit';
import { useDispatch,useSelector } from 'react-redux'
import { Navigate, useLocation, useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';

// These variables are used to return user informations
const initialState = {
    isModalDisplayed: false,
    modalTitle:"",
    modalBody:"",
    actionType: null,
    actionPayload: null
};



export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    

    DisplayModal: (state)=>{
      state.isModalDisplayed=true
    },

    closeModal: (state)=>{
     
      state.isModalDisplayed=false
      state.actionType = null
      state.actionPayload = null
      //console.log("this is the url: "+window.location.href)
      //console.log("this is the url to comp with: "+process.env.REACT_APP_FRONTEND_URL+"shipping#/order")
      // if (window.location.href===process.env.REACT_APP_FRONTEND_URL+"#/order"){
      //   window.location.replace("/")
        
      // }

      // if (window.location.href===process.env.REACT_APP_FRONTEND_URL){
      //   //console.log("this is the url: "+window.location.href)
      //   window.location.reload()
      //   Cookies.remove('cartItems')
      //   Cookies.remove('cartNbrItems')
      //   Cookies.remove('cartTotalPrice')
      //   Cookies.remove('shippingAddress')
        
      // }
      
    },

    setModalTitle: (state,action)=>{
      state.modalTitle=action.payload
    },
    

    setModalBody: (state,action)=>{
      state.modalBody=action.payload
    },
    
    setActionType: (state,action)=>{
      state.actionType = action.payload
    },

    setActionPayload: (state,action)=>{
      state.actionPayload = action.payload
    },

  },
});

export const {DisplayModal, closeModal, setModalTitle, setModalBody, setActionType, setActionPayload} = modalSlice.actions;

export const selectisModalDisplayed = (state) => state.modal.isModalDisplayed;

export const selectModalTitle = (state) => state.modal.modalTitle;
export const selectModalBody = (state) => state.modal.modalBody;
export const selectActionType = (state) => state.modal.actionType;
export const selectActionPayload = (state) => state.modal.actionPayload;

export default modalSlice.reducer;
